<template>
  <ul>
    <li
      class="text-dark-gray uppercase my-12 grid grid-cols-3 gap-12 lg:flex lg:gap-0 lg:mr-16 items-baseline"
      v-if="filteredBy.length > 0">
      Filtered By:
      <div class="col-span-2">
        <filter-badge
          v-for="option in filteredBy"
          :key="`${option.filter}:${option.value}`"
          :value="option.value"
          :input="query[option.filter]"
          @input="queryActions.sync({[option.filter]: $event, page: 1})"
          class="mx-4 mb-4">
          {{ option.text }}
        </filter-badge>
      </div>
    </li>
    <li
      class="text-dark-gray uppercase grid grid-cols-3 gap-16 lg:flex lg:gap-0 lg:mr-16 items-baseline"
      v-if="query.sortBy">
      Sorted By:
      <div class="col-span-2">
        <filter-badge
          :input="query.sortBy"
          @input="queryActions.sync({sortBy: $event, page: 1})"
          :value="query.sortBy"
          class="mx-4 mb-4">
          {{ sortedBy.text }}
        </filter-badge>
      </div>
    </li>
  </ul>
</template>
<script>
import FilterBadge from './FilterBadge'
import flatMap from 'lodash/flatMap'
import pickBy from 'lodash/pickBy'

export default {
  components: {
    FilterBadge,
  },

  inject: ['query', 'filters', 'queryActions'],

  computed: {
    sortedBy () {
      return this.filters.sortBy.options.find(option => option.value === this.query.sortBy)
    },

    filteredBy () {
      return this.flattenedOptions.filter(({ filter, value }) => {
        return Array.isArray(this.query[filter]) ?
            this.query[filter].includes(value) :
            this.query[filter] === value
      })
    },

    flattenedOptions () {
      return flatMap(this.filters, filter => filter.options).filter(option => option.filter !== 'sortBy')
    },
  }
}
</script>
